export const ESTIMATED_ARRIVAL_DATE = 'js-estimated-arrival-date';
